import React from 'react';
import PropTypes from 'prop-types';
import { Alert as AlertUI } from 'xland-ui';
import Button from 'components/Buttons/Button';

function Alert(props) {
  const {
    type,
    text,
    className = '',
    buttons = null,
    onClick = null,
  } = props;

  return (
    <AlertUI
      type={type}
      text={text}
      className={className}
      onClick={onClick}
    >
      {buttons?.length ? (
        <div className='buttons'>
          {buttons.map(button => <Button key={button.text} className='btn-sm' {...button} />)}
        </div>
      ) : null}
    </AlertUI>
  );
}

Alert.propTypes = {
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  buttons: PropTypes.array,
  onClick: PropTypes.func,
};

export default Alert;
